import React from 'react';
import css from './FilterSidebar.module.css';
import { FormattedMessage } from 'react-intl';
const GroupTypeFilterOption = ({
  groupTypeFilterOptions,
  handleClearFilter,
  handleRadioChange,
  paramKey,
  selectedValue,
}) => {
  return (
    <div className={css.ageFilterSection}>
      <div className={css.ageSectionHeader}>
        <h3 className={css.ageTitle}>
          <FormattedMessage id="FilterCategories.groupType" />
        </h3>
        <button className={css.ageClearButton} onClick={() => handleClearFilter(paramKey)}>
          <FormattedMessage id="FilterCategories.clear" />
        </button>
      </div>
      <div className={css.ageScrollable}>
        {groupTypeFilterOptions.map(({ value, label }) => {
          const isChecked = selectedValue.includes(value);
          return (
            <label key={value} className={css.ageRadioLabel}>
              <input
                type="radio"
                name={paramKey}
                value={value}
                checked={isChecked}
                onChange={e => handleRadioChange(e, paramKey)}
              />
              <span>{label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default GroupTypeFilterOption;
